exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card01{background-color:#292f4c;height:200px;border-radius:25px;margin:10px}.icon{align-self:center;color:#fff}.courser-style{cursor:pointer}.div-table-head{font-weight:600}.div-table-row{display:flex;justify-content:space-between;width:auto;clear:both;cursor:pointer;padding:5px}.div-table-row:hover{background-color:#efefef}.div-table-col{float:left;display:table-column;width:200px;height:30px}.children{margin-left:30px}.action-col{display:flex;align-items:center;flex-wrap:wrap;justify-content:space-between}.my-filter .chips-container{background:#f5dddd!important;color:#000!important}", ""]);

// exports
